import { CasProfileApi } from "@jti/rest-api";

import { TAGS } from "../common/tags";
import { profileApiSlice } from "../profileApiSlice";
import type { ProfileApiBuilder } from "../profileApiSlice.types";
import { handleProfileApiError } from "../utils/handleProfileApiError";

type UpdateAgeVerificationResponse = {
  is_age_verified: boolean;
};

export const updateAgeVerificationEndpoint = (builder: ProfileApiBuilder) => ({
  updateAgeVerification: builder.mutation<UpdateAgeVerificationResponse, string>({
    queryFn: async (avpUuid) => {
      try {
        return { data: await CasProfileApi.init().updateAgeVerification(avpUuid) };
      } catch (error: unknown) {
        return handleProfileApiError(error);
      }
    },
    onQueryStarted: (_, { dispatch, queryFulfilled }) => {
      void queryFulfilled
        .then(({ data }) => {
          dispatch(
            profileApiSlice.util.updateQueryData("getProfile", undefined, (draft) => {
              draft.is_age_verified = data.is_age_verified;
            })
          );
        })
        .catch(() => undefined);
    },
    invalidatesTags: [TAGS.PROFILE],
  }),
});
